import React from "react";
import { Select } from "antd";
import { getCountryFlag } from "variables/constants";

const SelectOption = ({
  placeholder,
  options = [],
  className = "",
  value,
  onChange,
  showLabel = true,  
  showIcons = false, 
}) => {
  return (
    <div className={`bg-gray-50 rounded-lg h-9 flex items-center ${className}`}>
      <Select
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        allowClear={false}
        showSearch={false}
        listHeight={options.length * 32}
        className="w-full text-[14px]"
        optionLabelProp="label"
        variant="borderless"
        dropdownMatchSelectWidth={false}
      >
        {options.map((option) => {
          const icon = showIcons && option.code ? getCountryFlag(option.code) : null;
          const label = showLabel ? option.label : null;

          return (
            <Select.Option
              key={option.value}
              value={option.value}
              label={icon || label}
            >
              <div className="flex items-center gap-2">
                {icon}
                {label}
              </div>
            </Select.Option>
          );
        })}
      </Select>
    </div>
  );
};

export default SelectOption;
